<template>
  <div>
    <!-- 見出しは caption があるときだけ（無いときは高さも残さない。ヘッダーの絞り込み欄で他と高さをそろえるため） -->
    <label v-if="caption" class="block text-xs font-bold text-gray-700 relative">
      {{ caption }} <span v-if="required === true" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
    </label>
    <div class="flex relative" :class="[caption ? 'mt-1' : '', filled ? 'filled' : '']">
      <InputIcon v-if="error" iconName="ExclamationCircle" :iconColor="errorColor || 'red'" :message="errorMessage" />
      <DateInput
        :value="value"
        class="w-full"
        :class="error ? 'error' : ''"
        v-bind="$attrs"
        :min="min"
        :max="max"
        :availableDate="availableDate"
        :disabled="disabled"
        :clearable="clearable && !disabled"
        @change="$emit('change', $event)"
      />
    </div>
  </div>
</template>

<script>
import InputIcon from '@components/InputIcon.vue'
import DateInput from '@components/DateInput.vue'

/**
 * 日付欄（WmsDateInput の後継。新しく作る画面ではこちらを使ってください）
 *
 * ■ なぜ別に作ったか
 * WmsDateInput は value を watch して change を出し直しているため、
 * ・画面を開いた瞬間（親が初期値を入れたとき）にも change が飛ぶ
 * ・人が日付を選ぶと、DateInput の change と watch の change で 2 回飛ぶ
 * という動きになる。@change に検索や再計算を付けると、開いただけで走ったり二重に走ったりして困る。
 * WmsDateInput は 2026-09 時点で 36 ファイル・101 か所（うち 33 か所が @change 付き）で使われていて、
 * 中には初回の change に頼って動いている画面があるかもしれない。共通部品を直すと既存画面を壊す恐れがあるので、
 * 賃金画面（AkbsWage）を作るときに、この動きを直した別部品として WmsDateField を作った。
 *
 * ■ WmsDateInput との違い
 * ・change は人が日付を選んだ・消したときだけ出す（読み込み時や親からの代入では出さない）
 * ・caption が無ければ見出しの行を作らない（ヘッダーの絞り込み欄で他の欄と高さがそろう）
 * ・filled を渡すと中の入力欄が黄色（絞り込み中の色）になる
 *
 * ■ 使い方
 * props の名前は WmsDateInput と同じにしてあるので、乗り換えるときは import とタグ名を替えるだけでよい。
 * ただし既存画面を乗り換えるときは、初回の change に頼った処理が無いかを見てから替えること。
 */
export default {
  inheritAttrs: false,

  components: {
    InputIcon,
    DateInput
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    name: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: ''
    },
    // yyyy-mm-dd（空は ''）
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    errorColor: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    availableDate: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    // 絞り込み中の色（黄色）にするか
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/* 絞り込み中は中の入力欄を黄色に（申請一覧の絞り込み欄と同じ色） */
.filled >>> input[type=text] {
  background-color: #efdf8a;
  font-weight: bold;
}
</style>
